<template>
  <div>
    <ag-grid-vue :style="{width: '100%', height: height + 'px'}" class='ag-theme-balham-dark'
                 :gridOptions='gridOptions'
                 :rowData="records"
                 :suppressRowClickSelection="true"
                 :getContextMenuItems="getContextMenuItems">
    </ag-grid-vue>
    <b-modal
      ref="deleteModal"
      title="Delete infraction entry"
      ok-title="Delete"
      ok-variant="danger"
      cancel-title="Cancel"
      @ok="confirmDelete"
    >
      <div>Are you sure you want to delete this infraction entry?</div>
      <div class="mt-2" v-if="pendingDeleteRow">
        <div><strong>Staff:</strong> {{ pendingDeleteRow.staff || '-' }}</div>
        <div><strong>Action:</strong> {{ banType(pendingDeleteRow.type) || '-' }}</div>
        <div><strong>Reason:</strong> {{ pendingDeleteRow.reason || '-' }}</div>
        <div><strong>Duration:</strong> {{ formatDuration(pendingDeleteRow.days) }}</div>
        <div><strong>Date (UTC):</strong> {{ formatDateDisplay(pendingDeleteRow.date) }}</div>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import {AgGridVue} from 'ag-grid-vue'
  import {DefaultGridOptions} from "@/default_table_settings";
  import {applyGridPersistence} from "@/grid_persistence"
  import moment from 'moment';

  export default {
    props: {
      records: Array,
      userId: {
        type: Number,
        default: 0
      },
      username: {
        type: String,
        default: ''
      },
      server: {
        type: String,
        default: ''
      },
      height: {
        type: Number,
        default: 250
      }
    },
    data () {
      return {
        gridOptions: null,
        pendingDeleteRow: null
      }
    },
    components: {
      'ag-grid-vue': AgGridVue
    },
    methods: {
      createRowData () {
        return this.records
      },
      banType (type) {
        switch (type) {
          case 'P':
            return 'Permanently banned'
          case 'T':
            return 'Temporarily banned'
          case 'E':
            return 'Trade banned'
          case 'M':
            return 'Quiet banned'
          case 'N':
            return 'Notification'
          case '-':
          case 'U':
            return 'Unbanned'
          case 'A':
            return 'MAC banned'
          case 'V':
            return 'UserVar updated'
          case 'X':
            return 'PVP banned'
          case 'S':
            return 'Single-player banned'
          case 'Z':
            return 'Server Transfer'
          case 'C':
            return 'Username changed'
          default:
            return ''
        }
      },
      createColumnDefs () {
        let self = this
        return [
          {
            headerName: 'Staff',
            field: 'staff',
            filter: 'agTextColumnFilter'
          },
          {
            headerName: 'Action',
            field: 'type',
            filter: 'agTextColumnFilter',
            valueGetter: function (params) {
              return self.banType(params.data.type)
            }
          },
          {
            headerName: 'Reason',
            field: 'reason',
            filter: 'agTextColumnFilter'
          },
          {
            headerName: 'Duration',
            field: 'days',
            filter: 'agNumberColumnFilter',
            valueGetter: function (params) {
              if (params.data.days === 0) {
                return ''
              }
              return params.data.days + ' days'
            }
          },
          {
            headerName: 'Date',
            field: 'date',
            sortable: true,
            filter: 'agTextColumnFilter',
            cellRenderer: params => this.formatDateDisplay(params.value),
            tooltipValueGetter: params => {
              if (!params.value) return '';
              const m = moment(params.value);
              return `Local: ${m.local().format('YYYY-MM-DD HH:mm:ss')}`;
            }
          }
        ]
      },
      getContextMenuItems(params) {
        const items = ['copy', 'copyWithHeaders', 'separator', 'export'];
        if (!params || !params.node || !params.node.data) return items;
        if (!this.hasPermission(this.UserInfractionDelete)) return items;
        if (!params.node.data.id || !this.userId || !this.server) return items;
        items.unshift({
          name: 'Delete infraction',
          icon: '<i class="fa fa-trash text-danger"></i>',
          action: () => this.openDeleteModal(params.node.data)
        });
        return items;
      },
      openDeleteModal(row) {
        if (!row || !row.id) return;
        this.pendingDeleteRow = row;
        if (this.$refs.deleteModal) {
          this.$refs.deleteModal.show();
        }
      },
      confirmDelete() {
        const row = this.pendingDeleteRow;
        this.pendingDeleteRow = null;
        if (!row || !row.id || !this.userId || !this.server) return;
        this.emit('deleteInfraction', {
          id: row.id,
          user_id: this.userId,
          username: this.username,
          server: this.server
        });
        if (this.gridOptions && this.gridOptions.api) {
          this.gridOptions.api.applyTransaction({remove: [row]});
        }
      },
      formatDuration(days) {
        if (!days || Number(days) === 0) return '-';
        return `${days} days`;
      },
      onGridSizeChanged () {
        this.gridOptions.api.sizeColumnsToFit()
      }
    },
    beforeMount () {
      this.gridOptions = Object.assign({}, DefaultGridOptions, {
        suppressRowClickSelection: true,
        rowSelection: 'multiple'
      })
      applyGridPersistence(this.gridOptions, 'ban-history-grid')
      this.gridOptions.rowData = this.createRowData()
      this.gridOptions.columnDefs = this.createColumnDefs()
    }
  }
</script>

<style>
</style>
